<template>
  <div class="-wrapper-column -pt-5 -px-5 -height-100">
    <div class="-wrapper-column -height-100 -pb-1">
      <div class="-tile-container -mt-2 -pb-5 -bg-white -border-radius-1 -overflow-x-hidden -overflow-y-hidden">
        <div class="-wrapper-between -position-relative">
          <g-search-bar
            id="customer-list-portal-grid-searchbar"
            style="width: calc(100%);"
            no-border
            full
            placeholder="Search anything"
            v-model="searchText" />
         
        </div>
        <ag-grid-vue
            id="customer-list-list-portal-grid"
            class="ag-theme-balham"
            row-height="30"
            header-height="30"
            rowSelection="single"
            :modules="modules"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="IDPUserList.users"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :loadingOverlayComponentParams="loadingOverlayComponentParams"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
            :frameworkComponents="frameworkComponents"
            @grid-ready="onGridReady"
            @row-data-changed="onRowDataChanged"
            style="height: 500px;"
            @selection-changed="onSelectionChanged">
        </ag-grid-vue>
        <g-pagenation
            id="customer-list-grid-paging"
            class="-py-6 -pr-2"
            :page-no="payLoad.pageNo == 0 ? 1 : payLoad.pageNo"
            :page-size-list="pageSizeList"
            :page-size="payLoad.size"
            :total-count="!!IDPUserList && IDPUserList.totalCount ? IDPUserList.totalCount : 0"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from '../../mixin/AgGrid.mixin'
import TagCell from "@/pages/components/ag-grid/TagCell";
import CodeList from '@/code/CodeList'
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE, LOCALE} from "@/constants/constants";

export default {
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  data () {
    return {
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      payLoad: {},
      selectedValue: {},
      searchText: '',
      defaultColDef: {
        sortable: true,
        enableRowGroup: false,
        enablePivot: false,
        enableValue: false,
        filter: false,
        resizable: true
      },
      columnDefs: []
    }
  },
  computed: {
    ...mapGetters('user', [
      'IDPUserList',
      'codeIDPUserList',
      'userInfo'
    ]),
  },
  methods: {
    ...mapActions('user', ['getIDPUserList']),
    setColumn () {
      this.columnDefs = [
        
        { field: 'userName', headerName: this.$t('common.user_name'), unSortIcon: true, filter: false, cellStyle : {"cursor":"pointer"} },
        { field: 'userEmail', headerName: this.$t('common.email'), unSortIcon: true, filter: false, cellStyle : {"cursor":"pointer"} },
        { field: 'userTelNo', headerName: this.$t('common.phone'), unSortIcon: true, filter: false, cellStyle : {"cursor":"pointer"} },
        {
          field: 'useYn',
          headerName: this.$t('pages_user_CustomerList.header.status'),
          sortable: true,
          unSortIcon: true,
          cellRendererFramework: TagCell((params) => {
            let text = ''
            let color = ''
            if (params.value === 'Y') {
              text = this.$t('pages_user_CustomerList.row.active')
              color = 'green-'
            } else if (params.value === 'N') {
              text = this.$t('pages_user_CustomerList.row.deactive')
              color = 'gray-'
            } 
            return {
              text, color
            }
          }),
          cellStyle : {"cursor":"pointer"},
        },
        
      ]
    },
    onGridReady(params) {
      this.setGridParams(params)
      var that = this;
      that.columnDefs.forEach(item => {
        var column = that.gridColumnApi.getColumn(item.field + "_1")
        if (!column) {
          column = that.gridColumnApi.getColumn(item.field)
        }
        column.addEventListener('sortChanged', (value) => {
          const sortVal = column.getSort()
          that.payLoad.orderCol = item.field
          if (sortVal === 'desc') {
            that.payLoad.desc = true
          } else if (sortVal === 'asc') {
            that.payLoad.desc = false
          } else {
            that.payLoad.orderCol = null
            that.payLoad.desc = null
          }
          this.getIDPUserList(this.payLoad)
        })
      })
      this.fitGrid()
    },
    onSelectionChanged () {
      var selectedRows = this.gridApi.getSelectedRows();
      this.$emit('selected', selectedRows[0])
    },
    onRowDataChanged (e) {
      if (this.codeIDPUserList === CodeList.READY) {
        this.noRowsOverlayComponentParams.exception = false
        this.gridApi.showLoadingOverlay()
      } else if (this.codeIDPUserList === CodeList.EXCEPTION) {
        this.noRowsOverlayComponentParams.exception = true
        this.gridApi.showNoRowsOverlay()
      } else if (this.codeIDPUserList === CodeList.SUCCESS) {
        if (this.IDPUserList && this.IDPUserList.totalCount) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      }
      this.fitGrid()
    },
    onChangePageNo (pageNo) {
      this.payLoad.pageNo = pageNo;
      this.getIDPUserList(this.payLoad)
    },
    onChangePageSize (pageSize) {
      this.payLoad.size = pageSize;
      this.payLoad.pageNo = 1;
      this.getIDPUserList(this.payLoad)
    },
    onSearch() {
      this.payLoad.pageNo = 1;
      this.getIDPUserList(this.payLoad)
    },
  },
  watch: {
    searchText () {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.payLoad.pageNo = 1
        this.payLoad.searchText =  this.searchText;
        this.gridOptions.columnApi.resetColumnState();
        this.onSearch()
      }, 200);

    }
  },
  mounted () {
    if (this.IDPUserList.length === 0) {
      this.gridApi.showLoadingOverlay()
      this.fitGrid()
    }
    this.gridApi.context.parentComponents = this
  },
  beforeMount () {
    this.payLoad = {
      pageNo : 1,
      size : DEFAULT_PAGE_SIZE,
      searchText : this.searchText,
      orderCol : this.orderCol,
      desc : this.desc,
      siteCode: this.userInfo.siteCode,
      
    }
    this.getIDPUserList(this.payLoad)
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/user/components/IDPUserChoose.vue